import SearchAndFilterRow from "components/common/SearchAndFilterRow";
import Plans from "components/common/plans/plans.layout";
import { fetchBookmarkPlansAsync, setBookmarkedPlanList } from "components/features/library/Bookmark/Bookmark.slice";
import { useEffect, useState } from "react";
import { PAGE_SIZE, allPlansType } from "utils/CommonConstants";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { Bookmarkplans } from "./Bookmark";
import "./index.scss";

function Index() {
  const dispatch = useAppDispatch();
  const [pageNo, setPageNo] = useState(1);
  const bookmarkPlansList: any = useAppSelector((state: any) => state.bookmarkedPlans.bookmarkedPlansList);
  const bookmarkedPlanIdList: any = useAppSelector((state: any) => state.bookmarkedPlans.list);
  const isLoading = useAppSelector((state: any) => state.bookmarkedPlans.status);
  const selectedFunctionalAreas = useAppSelector((state: any) => state.app.selectedFunctionalAreas);
  const filterIds = useAppSelector((state: any) => state.app.filterIds);
  const searchText = useAppSelector((state) => state.app.searchText);
  const [inputText, setInputText] = useState(searchText);
  const totalRecords: any = useAppSelector((state: any) => state.bookmarkedPlans.totalRecords);
  const innCode = useAppSelector((state: any) => state.app.innCode);
  const innCodeBookmark: Bookmarkplans = bookmarkedPlanIdList.find((item: any) => item.innCode === innCode);
  const bookmarkPlanIds = innCodeBookmark ? innCodeBookmark.cmsId : [];
  const selectedPlanType = useAppSelector((state: any) => state.app.selectedPlanType);

  const getProps = (page?: number) => {
    return {
      filter: {
        innCode,
        ids: bookmarkPlanIds,
        functionalAreaIds: selectedFunctionalAreas,
        filterIds
      },
      pagination: {
        page: page ?? pageNo + 1,
        size: PAGE_SIZE
      },
      searchText: inputText,
      planType: selectedPlanType?.length > 0 ? selectedPlanType : [allPlansType]
    };
  };

  useEffect(() => {
    const props: any = getProps(1);
    if (inputText) props.sort = { property: "relevance", direction: "ASC" };
    if (bookmarkPlanIds.length > 0) {
      dispatch(fetchBookmarkPlansAsync(props));
      setPageNo(1);
    } else dispatch(setBookmarkedPlanList());
  }, [dispatch, bookmarkedPlanIdList, selectedFunctionalAreas, filterIds, innCode, inputText, selectedPlanType]);

  const fetchMore = () => {
    const props = getProps();
    dispatch(fetchBookmarkPlansAsync(props));
    setPageNo(pageNo + 1);
  };

  const getInputDetails = (inputText: string) => {
    if (inputText.length > 2 || !inputText) {
      setInputText(inputText);
    }
  };

  return (
    <>
      <SearchAndFilterRow getInputDetails={getInputDetails} inputText={inputText} />
      <Plans plansList={bookmarkPlansList} totalList={totalRecords} isLoading={isLoading} loadMore={fetchMore}></Plans>
    </>
  );
}

export default Index;
